import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { tap } from 'rxjs';
import { ActivityResponse } from 'src/app/model/dto/ActivityResponse';
import { CustomResponse } from 'src/app/model/dto/CustomResponse';
import { LOCALISATIONS } from 'src/app/model/localisations';
import { ProfilDetails } from 'src/app/model/profilDetails';
import { ActivityService } from 'src/app/modules/agenda/services/activity-services';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';
import { Subject, of } from 'rxjs';
import {
  debounceTime,
  filter,
  switchMap,
  catchError,
  takeUntil,
  finalize,
} from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { LieuDTO } from 'src/app/model/dto/activity-session';
import { Cities } from 'src/app/model/cities';

@Component({
  selector: 'app-formation-form',
  templateUrl: './formation-form.component.html',
  styleUrls: ['./formation-form.component.css'],
})
export class FormationFormComponent implements OnInit {
  submitSuccess: boolean = false;
  alreadyConfirm: boolean = false;
  filled: boolean = false;
  erreur: boolean = false;
  isSubmitting: boolean = false;
  isLoading: boolean = false;
  canRetry: boolean = false;
  infoResponse!: string;
  errorMessage: string | null = null;

  formationForm!: FormGroup;

  preciserSecteurCtrl!: FormControl;
  prenomCtrl!: FormControl;
  nomCtrl!: FormControl;
  sexeCtrl!: FormControl;
  anneeNaissanceCtrl!: FormControl;
  emailCtrl!: FormControl;
  emailConfirmCtrl!: FormControl;
  waveNumberCtrl!: FormControl;
  regionCtrl!: FormControl;
  secteurActiviteCtrl!: FormControl;
  villeCtrl!: FormControl;
  dateCtrl!: FormControl;
  datesDisponibles: any[] = [];
  consentementCtrl!: FormControl;
  creneauCtrl!: FormControl;

  showSpinner = false;
  lieuFormation!: any;
  creneauxDisponibles: string[] = [];
  activity!: ActivityResponse;
  activityId: number | undefined;
  cities: Cities[] = [];
  session: boolean = false;
  noSession: boolean = false;
  isClosed: boolean = false;
  showPreciser: boolean = false;
  telephoneDejaExistant: boolean = false;
  checkingTelephone: boolean = false;
  idActivite!: number;
  private destroy$ = new Subject<void>();
  private readonly OUVERTURE_AVANT_MIN = 30; // ouvert 30 min avant le début
  private readonly TOLERANCE_APRES_MIN = 60; // et jusqu'à 1 h après la fin

  constructor(
    private spinnerService: SpinnerServiceService,
    private formBuilder: FormBuilder,
    private activityService: ActivityService,
    private router: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.idActivite =
      Number(this.router.snapshot.paramMap.get('activiteId')) || 0;
    console.log('idActivite : ', this.idActivite);
    this.initControls();
    this.initForm();
    if (this.idActivite) {
      this.getCurrentCmomercant(this.idActivite);
    }
    console.log(LOCALISATIONS.Regions);
    this.waveNumberCtrl.valueChanges
      .pipe(
        tap((value) => {
          this.telephoneDejaExistant = false;
          // Dès qu'on a 9 chiffres, on bloque la soumission jusqu'à la réponse
          this.checkingTelephone = !!value && value.length === 9;
        }),
        debounceTime(400),
        filter((value) => !!value && value.length === 9),
        switchMap((value) =>
          this.activityService.checkTelephoneExists(value).pipe(
            tap((exists) => {
              this.checkingTelephone = false;
              this.telephoneDejaExistant = exists;
            }),
            catchError(() => {
              this.checkingTelephone = false;
              this.telephoneDejaExistant = false;
              return of(false);
            }),
          ),
        ),
        takeUntil(this.destroy$),
      )
      .subscribe();

    this.formationForm
      .get('secteurActivite')
      ?.valueChanges.subscribe((value) => {
        if (value === 'Autre') {
          this.showPreciser = true;
          console.log('la nouvelle valeur : ', value);
        } else {
          this.showPreciser = false;
          this.preciserSecteurCtrl.reset('');
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private getCitiesByIsoCode(isoCode: string) {
    this.activityService
      .cityListbyIsoCode(isoCode)
      .subscribe((villes: Cities[]) => {
        // ⚠️ nom de ta méthode
        this.cities = [...villes].sort((a, b) =>
          a.name.localeCompare(b.name, 'fr', { sensitivity: 'base' }),
        );
      });
  }

  private initControls() {
    this.prenomCtrl = this.formBuilder.control('', Validators.required);

    this.preciserSecteurCtrl = this.formBuilder.control('');
    this.nomCtrl = this.formBuilder.control('', Validators.required);
    this.sexeCtrl = this.formBuilder.control('', Validators.required);
    this.regionCtrl = this.formBuilder.control('', Validators.required);
    this.anneeNaissanceCtrl = this.formBuilder.control('', [
      Validators.required,
      Validators.pattern(/^\d{4}$/),
    ]);

    this.emailCtrl = this.formBuilder.control('', [Validators.email]);
    this.emailConfirmCtrl = this.formBuilder.control('', [Validators.email]);
    this.waveNumberCtrl = this.formBuilder.control('', [
      Validators.required,
      Validators.pattern('^[0-9]{9}$'),
    ]);
    this.secteurActiviteCtrl = this.formBuilder.control(
      '',
      Validators.required,
    );
    this.villeCtrl = this.formBuilder.control('', Validators.required);
    this.creneauCtrl = this.formBuilder.control('', Validators.required);
    this.consentementCtrl = this.formBuilder.control(
      false,
      Validators.requiredTrue,
    );
    this.dateCtrl = this.formBuilder.control('', Validators.required);
  }

  private initForm() {
    this.formationForm = this.formBuilder.group(
      {
        prenom: this.prenomCtrl,
        nom: this.nomCtrl,
        sexe: this.sexeCtrl,
        anneeNaissance: this.anneeNaissanceCtrl,
        email: this.emailCtrl,
        emailConfirm: this.emailConfirmCtrl,
        waveNumber: this.waveNumberCtrl,
        secteurActivite: this.secteurActiviteCtrl,
        ville: this.villeCtrl,
        creneau: this.creneauCtrl,
        region: this.regionCtrl,
        consentement: this.consentementCtrl,
        date: this.dateCtrl,
        preciserSecteur: this.preciserSecteurCtrl,
      },
      { validators: this.emailMatchValidator },
    );
  }
  validateAge(event: Event): void {
    const input = event.target as HTMLInputElement;

    let value = input.value.replace(/[^0-9]/g, '');

    if (value !== '') {
      let age = Number(value);

      if (age > 100) {
        age = 100;
      }

      input.value = age.toString();
      this.anneeNaissanceCtrl.setValue(age, { emitEvent: false });
    }
  }

  getAge(): number | null {
    const annee = Number(this.anneeNaissanceCtrl.value);
    const anneeActuelle = new Date().getFullYear();

    if (isNaN(annee) || annee < 1900 || annee > anneeActuelle) {
      return null;
    }

    return anneeActuelle - annee;
  }

  emailMatchValidator(group: FormGroup) {
    const email = group.get('email')?.value;
    const emailConfirm = group.get('emailConfirm')?.value;
    return email === emailConfirm ? null : { emailMismatch: true };
  }

  isFieldInvalid(controlName: string): boolean | null {
    const control = this.formationForm.get(controlName);
    return control && control.invalid && control.touched;
  }

  get emailsMismatch(): boolean {
    return (
      this.formationForm.hasError('emailMismatch') &&
      !!this.formationForm.get('emailConfirm')?.touched
    );
  }
  onSubmitForm() {
    if (
      this.isSubmitting ||
      this.telephoneDejaExistant ||
      this.checkingTelephone
    )
      return;

    if (this.formationForm.valid) {
      this.filled = false;
      this.isSubmitting = true;
      this.showSpinner = true;
      this.errorMessage = null;

      const formValue = this.formationForm.value;

      const lieuSelectionne = this.lieuFormation.find(
        (l: any) => l.id === formValue['ville'],
      );

      const dto = {
        firstName: formValue['prenom'],
        lastName: formValue['nom'],
        gender: formValue['sexe'],
        age: this.getAge(),
        email: formValue['email'],
        telephone: formValue['waveNumber'],
        secteurActivite:
          formValue['secteurActivite'] == 'Autre'
            ? formValue['preciserSecteur']
            : formValue['secteurActivite'],
        ville: lieuSelectionne ? lieuSelectionne.lieu : formValue['ville'],
        region: formValue['region'],
        date: formValue['date'],
        creneau: formValue['creneau'],
      };

      console.log('Formulaire soumis :', dto);

      if (this.activityId != undefined) {
        window.scrollTo(0, 0);
        this.activityService
          .commercantLivreurSubmission(dto, this.activityId)
          .pipe(
            tap((response) => {
              console.log('La reponse apres soumission : ', response);
              switch (response.status) {
                case 200:
                  this.formationForm.reset();
                  this.submitSuccess = true;
                  this.alreadyConfirm = false;
                  this.session = false;
                  this.noSession = false;
                  this.infoResponse = response.object as string;
                  break;

                case 409:
                  this.alreadyConfirm = true;
                  this.submitSuccess = false;
                  this.session = false;
                  this.noSession = false;
                  this.infoResponse = response.object as string;
                  break;

                case 404:
                  this.submitSuccess = false;
                  this.session = false;
                  this.noSession = true;
                  this.alreadyConfirm = false;
                  break;

                case 400:
                  this.canRetry = false;
                  this.errorMessage =
                    response.message ??
                    'Les informations saisies sont invalides.';
                  break;
              }
            }),
            finalize(() => {
              this.isSubmitting = false;
              this.showSpinner = false;
            }),
          )
          .subscribe({
            error: (err) => {
              console.error('Erreur lors de la soumission : ', err);
              this.canRetry = true;
              this.errorMessage =
                'Vérifiez votre connexion internet puis réessayez.';
            },
          });
      } else {
        this.isSubmitting = false;
        this.showSpinner = false;
        this.errorMessage = 'Session introuvable. Rechargez la page.';
      }
    } else {
      this.filled = true;
      this.formationForm.markAllAsTouched();
    }
  }

  onlyNumbers(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.replace(/\D/g, '');

    input.value = value;
    this.waveNumberCtrl.setValue(value, { emitEvent: false });
  }

  private get today(): Date {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  }

  get lieuxDisponibles(): any[] {
    const result = this.lieuFormation.filter(
      (lieu: any) =>
        lieu.dates.length === 0 ||
        lieu.dates.some((d: any) => d.date >= this.today),
    );
    // console.log(
    //   'today:',
    //   this.today,
    //   'lieux dispo:',
    //   result.map((l: any) => l.lieu),
    // );
    return result;
  }

  get lieuxColonne1(): any[] {
    const milieu = Math.ceil(this.lieuxDisponibles.length / 2);
    return this.lieuxDisponibles.slice(0, milieu);
  }

  get lieuxColonne2(): any[] {
    const milieu = Math.ceil(this.lieuxDisponibles.length / 2);
    return this.lieuxDisponibles.slice(milieu);
  }
  onlyYear(event: Event): void {
    const input = event.target as HTMLInputElement;

    let value = input.value.replace(/\D/g, '').slice(0, 4);

    input.value = value;
    this.anneeNaissanceCtrl.setValue(value, { emitEvent: false });
  }

  onLieuChange(lieuId: number): void {
    const lieu = this.lieuFormation.find((l: any) => l.id === lieuId);
    // Ne garder que les dates futures
    this.datesDisponibles = (lieu?.dates ?? []).filter(
      (d: any) => d.date >= this.today,
    );
    this.dateCtrl.reset('');
    this.creneauxDisponibles = [];
    this.creneauCtrl.reset('');
    this.creneauCtrl.clearValidators();
    this.creneauCtrl.updateValueAndValidity();
    if (this.datesDisponibles.length === 0) {
      this.dateCtrl.clearValidators();
    } else {
      this.dateCtrl.setValidators(Validators.required);
    }
    this.dateCtrl.updateValueAndValidity();
  }

  onDateChange(dateLabel: string): void {
    const lieu = this.lieuFormation.find(
      (l: any) => l.id === this.villeCtrl.value,
    );
    const dateObj = lieu?.dates.find((d: any) => d.label === dateLabel);
    this.creneauxDisponibles = this.filteredCreneaux(dateObj?.creneaux ?? []);
    this.creneauCtrl.reset('');
    if (this.creneauxDisponibles.length === 0) {
      this.creneauCtrl.clearValidators();
    } else {
      this.creneauCtrl.setValidators(Validators.required);
    }
    this.creneauCtrl.updateValueAndValidity();
  }

  get lieuSelectionneLabel(): string {
    return (
      this.lieuFormation.find((l: any) => l.id === this.villeCtrl.value)
        ?.lieu ?? ''
    );
  }

  // ===== DÉBUT MODIF : filtre des créneaux, quels que soient leurs horaires =====
  /**
   * Garde le créneau en cours selon l'heure actuelle :
   * ouvert 30 min avant son début, jusqu'à 1 h après sa fin.
   * Le dernier créneau de la journée reste ouvert jusqu'à minuit.
   */
  // ===== DÉBUT MODIF : fenêtres d'inscription sans chevauchement inutile =====

  filteredCreneaux(creneaux: string[]): string[] {
    const now = new Date();
    const heureActuelle = now.getHours() * 60 + now.getMinutes();

    const horaires = creneaux.map((c) => {
      const [debut, fin] = c.split(' - ').map((h) => this.enMinutes(h));
      return { debut, fin };
    });

    return creneaux.filter((_, i) => {
      const { debut, fin } = horaires[i];
      const ouverture = debut - this.OUVERTURE_AVANT_MIN;

      const suivant = horaires[i + 1];
      const fermeture = suivant
        ? // fermé quand le suivant ouvre, mais jamais avant sa propre fin
          Math.min(
            fin + this.TOLERANCE_APRES_MIN,
            Math.max(fin, suivant.debut - this.OUVERTURE_AVANT_MIN),
          )
        : // dernier créneau : ouvert jusqu'à minuit
          24 * 60;

      return heureActuelle >= ouverture && heureActuelle <= fermeture;
    });
  }
  // ===== FIN MODIF =====

  // ===== DÉBUT AJOUT : en-tête de l'activité =====
  /** L'activité tient sur une seule journée ? */
  get memeJour(): boolean {
    return this.activity?.openDate === this.activity?.closeDate;
  }

  /** Villes de l'activité, séparées par des virgules */
  get villesActivite(): string {
    return this.lieuFormation.map((l: any) => l.lieu).join(', ');
  }

  /** "09:00:00" → "09:00" (accepte aussi le type Time du modèle) */
  heureCourte(heure: unknown): string {
    if (!heure) {
      return '';
    }
    if (typeof heure === 'string') {
      return heure.slice(0, 5);
    }
    // Cas d'un objet Time { hours, minutes }
    const t = heure as { hours?: number; minutes?: number };
    const hh = String(t.hours ?? 0).padStart(2, '0');
    const mm = String(t.minutes ?? 0).padStart(2, '0');
    return `${hh}:${mm}`;
  }

  // ===== FIN AJOUT =====

  /** "09h" → 540, "09h30" → 570 */
  private enMinutes(heure: string): number {
    const [h, m] = heure.trim().split('h');
    return Number(h) * 60 + (Number(m) || 0);
  }
  // ===== FIN MODIF =====

  private getCurrentCmomercant(id: number): void {
    this.activityService
      .getActivityByIdV2(id)
      .pipe(
        tap((response: CustomResponse) => {
          if (response.status == 200) {
            this.activity = response.object as ActivityResponse;
            console.log('activity : ', this.activity);

            if (this.activity.isClosed == true) {
              this.session = false;
              this.noSession = false;
              this.isClosed = true;
              this.spinnerService.hideSpinner();
              this.isLoading = false;
            } else {
              this.session = true;
              this.noSession = false;
              this.isClosed = false;
              this.spinnerService.hideSpinner();
              this.isLoading = false;
              this.activityId = this.activity.id;
              this.lieuFormation = this.versLieuFormation(
                this.activity.lieux ?? [],
              );

              // ===== DÉBUT AJOUT : villes de résidence selon le pays de l'activité =====
              const codeIso = (this.activity.countryFlag ?? 'sn').toUpperCase();
              this.getCitiesByIsoCode(codeIso);
              // ===== FIN AJOUT =====
              console.log('lieuFormation : ', this.lieuFormation);
            }
          } else if (response.status == 404) {
            this.session = false;
            this.noSession = true;
            this.isClosed = false;
            this.spinnerService.hideSpinner();
            this.isLoading = false;
          }
        }),
      )
      .subscribe();
  }

  closeError() {
    this.errorMessage = null;
  }

  retrySubmit() {
    this.errorMessage = null;
    this.onSubmitForm();
  }

  // ===== DÉBUT AJOUT : conversion des lieux du back vers l'ancien format =====
  /**
   * Transforme les lieux renvoyés par le back (ville → jours → créneaux)
   * en la structure de l'ancien tableau lieuFormation codé en dur :
   * { id, lieu, dates: [{ id, label, date, creneaux: ['09h - 13h', ...] }] }
   */
  private versLieuFormation(lieux: LieuDTO[]): any[] {
    return lieux.map((lieu, i) => ({
      id: i,
      lieu: lieu.ville,
      dates: lieu.jours.map((jour, j) => ({
        id: j,
        label: this.libelleJour(jour.date, jour.salle),
        date: this.versDateLocale(jour.date),
        creneaux: jour.creneaux.map(
          (c) => `${this.versHeure(c.debut)} - ${this.versHeure(c.fin)}`,
        ),
        creneauxIds: jour.creneaux.map((c) => c.id), // pour plus tard
      })),
    }));
  }

  /** "2026-10-06" → Date locale (sans décalage de fuseau) */
  private versDateLocale(date: string): Date {
    const [a, m, j] = date.split('-').map(Number);
    return new Date(a, m - 1, j);
  }

  /** "2026-10-06" + "CEDEPS" → "Mardi 06 Octobre 2026 (CEDEPS)" */
  private libelleJour(date: string, salle: string | null): string {
    const texte = this.versDateLocale(date)
      .toLocaleDateString('fr-FR', {
        weekday: 'long',
        day: '2-digit',
        month: 'long',
        year: 'numeric',
      })
      .replace(/(^|\s)\S/g, (lettre) => lettre.toUpperCase());
    return salle ? `${texte} (${salle})` : texte;
  }

  /** "09:00" → "09h", "09:30" → "09h30" */
  private versHeure(heure: string): string {
    const [h, m] = heure.split(':');
    return m === '00' ? `${h}h` : `${h}h${m}`;
  }
  // ===== FIN AJOUT =====
}
